var map = {
	"./avi2.png": 918,
	"./icon_green.png": 919,
	"./icon_red.png": 920,
	"./icon_vacio.png": 921,
	"./icon_yellow.png": 922,
	"./jpg2.png": 923,
	"./pdf2.png": 924,
	"./png2.png": 925,
	"./txt2.png": 926,
	"./xls2.png": 927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 917;